import { SET_THEME, SET_CONNECTION_REFERENCE, SET_HEADER_VISIBILITY, SET_MAIN_MENU_VISIBILITY, SET_FOOTER_VISIBILITY, REFRESH_STATUS_BAR } from "./Constants";
import type { AppThunk } from "@/store/thunk";

export const setTheme = (value: string): AppThunk => async (dispatch) =>
{
    dispatch(
    {
        type: SET_THEME,
        payload: value,
    });
};

export const setConnectionReference = (value: unknown): AppThunk => async (dispatch) =>
{
    dispatch(
    {
        type: SET_CONNECTION_REFERENCE,
        payload: value,
    });
};

export const setHeaderVisibility = (value: boolean): AppThunk => async (dispatch) =>
{
    dispatch(
    {
        type: SET_HEADER_VISIBILITY,
        payload: value,
    });
};

export const setMainMenuVisibility = (value: boolean): AppThunk => async (dispatch) =>
{
    dispatch(
    {
        type: SET_MAIN_MENU_VISIBILITY,
        payload: value,
    });
};

/**
 * Fuerza a la barra de estado a volver a pedir los avisos al servidor. La barra los carga una sola vez, al
 * resolverse el usuario, así que sin esto un aviso que el backend acaba de retirar (al firmar un KYC) o de
 * crear (la comprobación de caducidad del login) no se refleja hasta la siguiente carga de página.
 * Es un contador, no un booleano: cada disparo tiene que cambiar el valor para reactivar el efecto.
 */
export const refreshStatusBar = (): AppThunk => async (dispatch) =>
{
    dispatch(
    {
        type: REFRESH_STATUS_BAR,
    });
};

export const setFooterVisibility = (value: boolean): AppThunk => async (dispatch) =>
{
    dispatch(
    {
        type: SET_FOOTER_VISIBILITY,
        payload: value,
    });
};